export const customFLIFilters = {
  filter: 'agMultiColumnFilter',
  filterParams: {
    filters: [
      {
        title: 'ORDER NUMBER',
        filter: 'agSetColumnFilter',
        display: 'subMenu',
        filterParams: {
          valueGetter: (params) => params.data?.order_number || '',
        },
      },
      {
        title: 'FLAGS',
        filter: 'agSetColumnFilter',
        display: 'subMenu',
        filterParams: {
          valueGetter: ({ data }) => [
            ...(data?.is_multi_customer ? ['Multi-Customer Order'] : []),
            ...(data?.new_version_available ? ['New Version Available'] : []),
          ],
        },
      },
    ],
  },
}
